import React from "react"
import Utils from "../../utils/node.utils"
import { StaticQuery, graphql } from "gatsby"
import StaticPage from "../../components/StaticPage/StaticPage"
import {
  createOverlay,
  createContentList,
} from "../../contentfunctions/about.js"

import Carousel1 from "../../images/about/about-us-min.jpeg"

const AboutIndexPage = ({ location }) => {
  Utils.NavigateToBrowserLanguage("nl", "/about", location.state)
  return (
    <StaticQuery
      query={pageQuery}
      render={data => {
        const commonContentMap = Utils.ContentListToMap(
          data.commonContent.item.content
        )
        const contentMap = Utils.ContentListToMap(
          data.aboutContent.item.content
        )
        const img = {
          src: Carousel1,
          altText: contentMap.seo_title.value,
          caption: contentMap.seo_description.value,
        }
        return (
          <StaticPage
            title={contentMap.seo_title.value}
            description={contentMap.seo_description.value}
            img={img}
            originPage="about"
            language="nl"
            location={location}
            contentMap={contentMap}
            commonContentMap={commonContentMap}
            breadCrumbs={["menu_home", "menu_about"]}
            createContentFun={createContentList}
            createOverlayFun={createOverlay}
            keywords={Utils.GetKeywordsFromTags(data.aboutContent.item.tags)}
          />
        )
      }}
    />
  )
}

export default AboutIndexPage

const pageQuery = graphql`
  {
    aboutContent: aboutContentNlnl {
      item {
        key
        tags {
          content {
            key
            value
          }
        }
        content {
          key
          value
        }
      }
    }

    commonContent: commonContentNlnl {
      item {
        key
        content {
          key
          value
        }
      }
    }
  }
`
